import { Routes } from '@angular/router';
import { AuthGuard } from './helpers/auth.guard';
import { Role } from './enum/role';
import { ClientId } from './enum/clientId';
import { UnsavedChangesGuard } from './helpers/canDeactivate.guard';
import { MustReadMessageGuard } from './helpers/mustReadMessage.guard';

export const routes: Routes = [
  {
    path: 'callback',
    loadComponent: () =>
      import('./oauth/callback/authCallback.component').then(
        (mod) => mod.AuthCallbackComponent
      ),
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    data: { roles: Role.None }
  },
  {
    path: 'login',
    loadComponent: () =>
      import('./login/login.component').then((mod) => mod.LoginComponent),
    canActivate: [AuthGuard],
    data: { roles: Role.None }
  },
  {
    path: 'dashboard',
    loadComponent: () =>
      import('./layout/layout.component').then((mod) => mod.LayoutComponent),
    runGuardsAndResolvers: 'always',
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./home/home.component').then((mod) => mod.HomeComponent),
        canActivate: [AuthGuard],
        data: { clientId: [ClientId.Pabui] }
      },
      {
        path: 'work-plan',
        loadComponent: () =>
          import('./workPlan/workPlan.component').then(
            (mod) => mod.WorkPlanComponent
          ),
        canActivate: [AuthGuard, MustReadMessageGuard],
        data: { clientId: [ClientId.Pabui] }
      },
      {
        path: 'resident/:id/intervention',
        loadComponent: () =>
          import('./resident/intervention/residentIntervention.component').then(
            (mod) => mod.ResidentInterventionComponent
          ),
        canActivate: [AuthGuard],
        data: { clientId: [ClientId.Pabui] }
      },
      {
        path: 'resident/:id/accidents',
        loadComponent: () =>
          import('./resident/accident/accident.component').then(
            (mod) => mod.AccidentComponent
          ),
        canActivate: [AuthGuard],
        data: { clientId: [ClientId.Pabui] }
      },
      {
        path: 'resident/:id/accident/:idAccident',
        loadComponent: () =>
          import('./resident/accident/add/addAccident.component').then(
            (mod) => mod.AddAccidentComponent
          ),
        canActivate: [AuthGuard],
        canDeactivate: [UnsavedChangesGuard],
        data: { clientId: [ClientId.Pabui] }
      },
      {
        path: 'resident/:id/accident',
        loadComponent: () =>
          import('./resident/accident/add/addAccident.component').then(
            (mod) => mod.AddAccidentComponent
          ),
        canActivate: [AuthGuard],
        canDeactivate: [UnsavedChangesGuard],
        data: { clientId: [ClientId.Pabui] }
      },
      {
        path: 'resident/:id/notes',
        loadComponent: () =>
          import('./resident/notes/notes.component').then(
            (mod) => mod.NotesComponent
          ),
        canActivate: [AuthGuard],
        data: { clientId: [ClientId.Pabui] }
      },
      {
        path: 'resident/:id',
        loadComponent: () =>
          import('./resident/detail/residentDetail.component').then(
            (mod) => mod.ResidentDetailComponent
          ),
        canActivate: [AuthGuard],
        data: { clientId: [ClientId.Pabui] }
      },
      {
        path: 'residents',
        loadComponent: () =>
          import('./resident/resident.component').then(
            (mod) => mod.ResidentComponent
          ),
        canActivate: [AuthGuard, MustReadMessageGuard],
        data: { clientId: [ClientId.Pabui] }
      },
      {
        path: 'maintenance/list',
        loadComponent: () =>
          import('./maintenance/maintenance.component').then(
            (mod) => mod.MaintenanceComponent
          ),
        canActivate: [AuthGuard, MustReadMessageGuard],
        data: { clientId: [ClientId.Pabui] }
      },
      {
        path: 'maintenance',
        loadComponent: () =>
          import('./maintenance/addMaintenance/addMaintenance.component').then(
            (mod) => mod.AddMaintenanceComponent
          ),
        canActivate: [AuthGuard],
        canDeactivate: [UnsavedChangesGuard],
        data: { clientId: [ClientId.Pabui] }
      },
      {
        path: 'maintenance/:id',
        loadComponent: () =>
          import('./maintenance/addMaintenance/addMaintenance.component').then(
            (mod) => mod.AddMaintenanceComponent
          ),
        canActivate: [AuthGuard],
        canDeactivate: [UnsavedChangesGuard],
        data: { clientId: [ClientId.Pabui] }
      },
     
     
      {
        path: 'intershift',
        loadComponent: () =>
          import('./intershift/intershift.component').then(
            (mod) => mod.IntershiftComponent
          ),
        canActivate: [AuthGuard],
        data: { clientId: [ClientId.Pabui] }
      },
      {
        path: 'messages',
        loadComponent: () =>
          import('./messages/messages.component').then(
            (mod) => mod.MessagesComponent
          ),
        canActivate: [AuthGuard],
        data: { clientId: [ClientId.Pabui] }
      },
      {
        path: 'intervention/:id',
        loadComponent: () =>
          import('./intervention/intervention.component').then(
            (mod) => mod.InterventionComponent
          ),
        canActivate: [AuthGuard],
        data: { clientId: [ClientId.Pabui] }
      }
    ]
  },
  {
    path: '**',
    redirectTo: 'dashboard'
  }
];
